import Vue from 'vue'
import Router from 'vue-router'
import ChatButton from './views/ChatButton.vue'
// const ChatButton = () => import('./views/ChatButton.vue')
// const Convo = () => import('./views/Convo.vue')
const Convo = () => import(/*webpackChunkName: "convo" */ './views/Convo.vue')
const ConvoList = () => import(/*webpackChunkName: "convo-list" */ './views/ConvoList.vue')
const CustomScreen = () => import(/*webpackChunkName: "custom-screen" */ './views/CustomScreen.vue')

Vue.use(Router)

const routes = [
	{path: '/chat-button', name: 'chat-button', component: ChatButton},
	{path: '/convo/:convoId?', name: 'convo', component: Convo},
	{path: '/convo-list', name: 'convo-list', component: ConvoList},
	{
		path: '/custom-screen/:id',
		name: 'custom-screen',
		component: CustomScreen,
	},
]

export default new Router({
	mode: 'abstract',
	routes,
})
